import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { get } from "lodash";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import { translateProps } from "MODULES/shared/decorators";
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import api from "APP_ROOT/api";
import { EXCHANGE_CORE_DUE_DAYS } from "APP_ROOT/constants";
import { useSettings } from "APP_ROOT/hooks/useCurrentUser";
import Form from "./Form";

export function New({ creating, close, currentUser, ...props }) {
  const settings = useSettings();
  const initialValues = {
    seller_credit_percent: "25.0",
    core_due_days: get(settings, EXCHANGE_CORE_DUE_DAYS, 30),
    dim_weight: false,
    exchange_sale: false,
    condition: null
  };

  return (
    <Modal open={creating} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Add a Part</h4>
      </Header>
      <Form
        initialValues={{ ...initialValues, seller_id: currentUser.id }}
        {...props}
        close={close}
        lineItem={Map()}
        selectedSeller={currentUser}
        newRecord
      />
    </Modal>
  );
}

New.propTypes = {
  creating: T.bool.isRequired,
  close: T.func.isRequired,
  ...WithCurrentUser
};

const withSubmit = translateProps(({ salesOrder }) => ({
  onSubmit: data => api.salesOrders.lineItems.create(salesOrder.get("id"), data)
}));

export default withSalesOrder(withCurrentUser(withSubmit(New)));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/New.jsx